export default [
  { title: 'Stores', routeName: 'merchants' },

  { title: 'Products', routeName: 'merchants-products' },

  { title: 'Invoices', routeName: 'merchants-invoices' },

  { title: 'Fees', routeName: 'merchants-fees' },
];
